module.exports = __webpack_public_path__ + "static/img/img7.dbda3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img7.png
// module id = 3PRl
// module chunks = 1